import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';

import { OrigamiHttpResponse, OrigamiResponse, ServiceBase } from './base/service.base';
import { ErrorCode } from '@app/origami-api/constants/error-codes';

export namespace FileUploadServiceModel {
  export interface UploadFileChunkResult {
    fileUid: string;
    uploaded: boolean;
  }

  export interface CombineFileChunksResult {
    FileSize: number;
    FileToken: string;
  }
}

@Injectable()
export class FileUploadService extends ServiceBase {
  serviceUrl = 'FileUploadService.svc';

  uploadFile(file, siteId, silentErrorCodes: ErrorCode[] = null): Observable<OrigamiHttpResponse> {
    const formData = new FormData();
    const options = { headers: new HttpHeaders() };
    formData.append('$$SITEID$$', siteId);
    formData.append('file', file);
    return this.origamiPost('/UploadFile', formData, options, silentErrorCodes, true);
  }

  combineFileChunks(body: {
    fileId: string;
  }): Observable<OrigamiResponse<FileUploadServiceModel.CombineFileChunksResult>> {
    return this.origamiPost('/CombineFileChunks', body, null, null, true);
  }
}
